import { Component, Input } from "@angular/core";

@Component({
  selector: "app-page-wrapper",
  templateUrl: "./page-wrapper.component.html",
  host: { class: "tw-flex tw-w-full tw-h-full" },
})
export class PageWrapperComponent {
  @Input() title: string = "";
  /** On mobile, keep nav-action next to the title (instead of stacking below) and wrap title-extra to its own full-width row instead. */
  @Input() navActionInlineOnMobile: boolean = false;
}
